import * as styles from 'styles/pages/Styleguide.css'

// This space is for temporarily working with components in isolation.
// ----------------------------------------------------------------------------- //


const SGWorkspace = () => (
  <section className={ styles.sgWorkspace } />
)

export default SGWorkspace
